<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Hostel Events</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row">
            <div class="mr-2">
              <add-event-modal :hostels="hostels" @created="handleUpdateTable" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <hostel-event-table
              :data="data"
              :hostels="hostels"
              :loading="loading"
              @updateTable="handleUpdateTable"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddEventModal from '@/components/hostel/manage/hostel-event/add'
import HostelEventTable from '@/components/hostel/manage/hostel-event/index'

export default {
  name: 'HostelEventView',
  components: {
    AddEventModal,
    HostelEventTable,
  },
  data() {
    return {
      loading: false,
      data: [],
      hostels: [],
    }
  },
  mounted() {
    this.fetchEvents()
  },
  methods: {
    fetchEvents() {
      this.loading = true
      Promise.all([
        this.$http.get('/api/hostel/event/all'),
        this.$http.get('/api/hostel'),
      ])
        .then(([eventsRes, hostelsRes]) => {
          this.data = eventsRes.data.data
          this.hostels = hostelsRes.data.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleUpdateTable() {
      this.fetchEvents()
    },
  },
}
</script>
